import s from "./portfolio.module.scss";
import { Container } from "../../components/container";
import { Title } from "../../components/title";
import { PortfolioCard } from "../../components/portfolio/portfolioCard";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import portfolio from "./portfolios.json";
import {
  BsFillArrowLeftCircleFill,
  BsFillArrowRightCircleFill,
} from "react-icons/bs";
import { gsap } from "gsap";
import { useEffect, useContext } from "react";
import { ColorContext } from "../../context/colorContext";
import { useTranslation } from "react-i18next";

const items = portfolio.map((i) => <PortfolioCard {...i} />);
const PrevButton = ({ isDisabled }) => {
  const { color } = useContext(ColorContext);
  return (
    <button style={isDisabled ? { display: "none" } : null} className={s.prev}>
      <BsFillArrowLeftCircleFill
        style={{ verticalAlign: "middle", fontSize: 25, color: color }}
      />
    </button>
  );
};

const NextButton = ({ isDisabled }) => {
  const { color } = useContext(ColorContext);
  return (
    <button style={isDisabled ? { display: "none" } : null} className={s.next}>
      <BsFillArrowRightCircleFill
        style={{ verticalAlign: "middle", fontSize: 25, color: color }}
      />
    </button>
  );
};
export const Portfolio = ({ reference }) => {
  const { t } = useTranslation();
  useEffect(() => {
    let ctx = gsap.context(() => {
      gsap.from(`.${s.portfolio}`, {
        duration: 1,
        y: 100,
        opacity: 0,
      });
    }, reference);
    return () => ctx.revert();
  }, [reference]);
  return (
    <div className={s.portfolio}>
      <Container>
        <div className={s.title}>
          <Title span={t("portfolio_title2")} size={25}>
            {t("portfolio_title1")}
          </Title>
        </div>
        <hr />
        <AliceCarousel
          responsive={{ 0: { items: 1 }, 576: { items: 2 }, 768: { items: 3 } }}
          renderPrevButton={(a) => <PrevButton {...a} />}
          renderNextButton={(b) => <NextButton {...b} />}
          mouseTracking
          disableDotsControls
          items={items}
        />
      </Container>
    </div>
  );
};
